import React from 'react'
import { ShortcutKbd } from '@/components/ui/shortcut-kbd'
import type { MenuCommand, ObjectMenuCommands } from '../types/menu-items'
import { MobileMenuSection } from './mobile-menu-section'
import { StyledMenuItem, StyledSeparator } from './styled-menu-items'

type MobileObjectSectionProps = {
  commands: ObjectMenuCommands
  closeMenu: () => void
}

export const MobileObjectSection: React.FC<MobileObjectSectionProps> = ({
  commands,
  closeMenu,
}) => {
  const renderCommand = (command: MenuCommand) => (
    <StyledMenuItem
      key={command.label}
      disabled={command.disabled}
      onClick={() => {
        if (command.disabled) return
        command.action?.()
        closeMenu()
      }}
    >
      {command.label}
      {command.shortcutKey && <ShortcutKbd shortcutKey={command.shortcutKey} />}
    </StyledMenuItem>
  )

  return (
    <MobileMenuSection value="object" label="Object">
      {commands.grouping.map(renderCommand)}
      <StyledSeparator />
      {commands.locking.map(renderCommand)}
      <StyledSeparator />
      {renderCommand(commands.convertTextToShape)}
      <StyledSeparator />
      {/* The accordion has no nesting, so Path Operations is a heading + its items rather than a
          submenu. Same command, same gate as the desktop Object menu (desktop-object-menu.tsx). */}
      <div className="px-2 pb-1 pt-2 text-xs font-medium text-muted-foreground">
        Path Operations
      </div>
      {renderCommand(commands.textOnPath)}
    </MobileMenuSection>
  )
}
